import { useDataMapping } from "./DataMappingContext";

export function useChat() {
  const { state, dispatch } = useDataMapping();
  return {
    ...state.chat,
    addMessage: (message) => dispatch({ slice: "chat", type: "ADD_MESSAGE", message }),
    // Atomic on purpose — the reducer, not the caller, decides whether this starts a new assistant
    // bubble or extends the streaming one. Callers hold a last-render snapshot of `messages`, which is
    // always stale mid-stream. See the APPEND_TOKEN case in DataMappingContext.jsx.
    appendToken: (token) => dispatch({ slice: "chat", type: "APPEND_TOKEN", token }),
    resolveAssistant: (content) =>
      dispatch({ slice: "chat", type: "RESOLVE_ASSISTANT", content }),
    updateCodeExecutionOutput: (output) =>
      dispatch({ slice: "chat", type: "UPDATE_CODE_EXECUTION_OUTPUT", output }),
    setMessages: (messages) => dispatch({ slice: "chat", type: "SET_MESSAGES", messages }),
    setConnected: (connected) => dispatch({ slice: "chat", type: "SET_CONNECTED", connected }),
    setThinking: (thinking) => dispatch({ slice: "chat", type: "SET_THINKING", thinking }),
    // Separate from setThinking on purpose — see `isTurnActive` in DataMappingContext.
    setTurnActive: (active) => dispatch({ slice: "chat", type: "SET_TURN_ACTIVE", active }),
    setTokenUsage: (usage) =>
      dispatch({
        slice: "chat",
        type: "SET_TOKEN_USAGE",
        input: usage.input,
        output: usage.output,
        cacheRead: usage.cacheRead,
        cacheWrite: usage.cacheWrite,
      }),
  };
}
